/**
* @file 资源管理-车辆资源
* */
<template>
  <div id="shift">
    <custom-table :has-channel="pageConfig.hasChannel" ref="customTable" has-organization="true"
      :customOptions="pageConfig.customOptions" :columns="pageConfig.columns" :addText="this.btnPreFn(this.$route.name + '_add') ? '创建车辆' : ''"
      :import-columns="pageConfig.importColumns" :importDes="pageConfig.importDes"
      :importRemark="pageConfig.importRemark" import-rule-key="licenseNo" :excel-type="pageConfig.excelType"
      :import-rules="importRules" :import-excel="pageConfig.importExcel" @addFn="addFn">
      <template slot="table-operation">
        <el-table-column label="操作" width="135" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" size="mini" @click="editClick(row)">查看</el-button>
            <el-dropdown size="mini" @command="handleCommand($event, row)">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" v-if="mixinUserInfo.platformType == 1 || mixinUserInfo.platformType == 2">
                <template v-if="!row.driverName">
                  <el-dropdown-item command="add">添加值班司机</el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item command="update">修改值班司机</el-dropdown-item>
                  <el-dropdown-item command="unbind">解绑值班司机</el-dropdown-item>
                  <el-dropdown-item command="qrcode">车辆下单码</el-dropdown-item>
                  <!-- <el-dropdown-item command="surveyVehicle" v-if="btnPreFn('survey_vehicle', false)">客运监管
                  </el-dropdown-item> -->
                </template>
                <el-dropdown-item command="remove">删除</el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu slot="dropdown" v-else>
                <template v-if="!row.driverName">
                  <el-dropdown-item command="add"  v-if="btnPreFn($route.name + '_driver', false)">添加司机</el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item command="update" v-if="btnPreFn($route.name + '_driver', false)">修改司机</el-dropdown-item>
                  <el-dropdown-item command="unbind" v-if="btnPreFn($route.name + '_unbundling', false)">解绑司机</el-dropdown-item>
                  <el-dropdown-item command="qrcode" v-if="mixinUserInfo.platformType == 3">车辆下单码</el-dropdown-item>
                </template>
                <el-dropdown-item command="remove" v-if="btnPreFn('vehicle_remove', false)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
        <template slot="table-channel" v-if="mixinUserInfo.platformType == 3">
        <el-table-column label="归属渠道" width="120">
          <template slot-scope="{ row }">
            {{ row.channelName || '-' }}
          </template>
        </el-table-column>
      </template>
      </template>
      <template slot-scope="{ item, row }">
        <div v-if="item.prop === 'vehiclePhoto'">
          <el-image :src="mixinQiniuImg(row.vehiclePhoto, 95, 40)" :preview-src-list="[mixinQiniuImg(row.vehiclePhoto)]" />
        </div>
        <div v-else-if="item.prop === 'licenseNo'">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
            @dblclick="$utils.dblclickCopy"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </div>
        <template v-else-if="item.prop === 'driverName'">
          <span v-if="row.driverName" :style="{ color: row.driverName ? '#333' : '#999' }">{{ row.driverName }}</span>
        </template>
        <template v-else-if="item.prop === 'vehicleSeat'">
          {{ row.vehicleSeat }}座
        </template>
        <template v-else-if="['applyTime', 'created'].includes(item.prop)">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
      
      <template slot="importColumn" slot-scope="{ item, row }">
        <div v-if="
          item.prop === 'vehiclePhoto' ||
          item.prop === 'roadTransportCertificate' ||
          item.prop === 'drivingLicenseFront' ||
          item.prop === 'drivingLicenseBack'
        ">
          <img class="column-img" v-if="row[item.prop]" :src="mixinQiniuImg(row[item.prop])" />
          <div class="no-upload" v-else>未上传</div>
        </div>
        <template v-else-if="item.prop === 'vehicleSeat'">
          {{ row.vehicleSeat }}座
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
    <!--司机值班弹框-->
    <el-dialog class="shift-dialog" title="司机" :visible.sync="visible" width="600px" :close-on-click-modal="false">
      <div class="label">搜索司机</div>
      <div class="flex">
        <el-select v-model="keyWords" filterable remote placeholder="按司机名称、手机号码" :remote-method="remoteMethod"
          @change="selectChange">
          <el-option :disabled="item.isDisabled" v-for="item in searchDrivers" :key="item.driverId" :label="item.licenseNo
            ? `${item.driverName} ${item.driverPhone} ${item.licenseNo}`
            : `${item.driverName} ${item.driverPhone} 未绑定车辆`
            " :value="item.driverId"></el-option>
        </el-select>
      </div>

      <div class="label">【{{ organizationName }}】下的可选司机</div>
      <el-radio-group v-model="driverId">
        <el-radio :disabled="item.isDisabled" :label="item.driverId" v-for="item in drivers" :key="item.driverId">
          {{ item.driverName }}
        </el-radio>
      </el-radio-group>
      <div class="dialog-more" @click="moreClick" v-if="drivers.length > 0 && drivers.length < total">
        点击加载更多 <i class="el-icon-arrow-down"></i>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" :disabled="!this.driverId" @click="postFn">确 定</el-button>
      </span>
    </el-dialog>
    <!--查看二维码弹框-->
    <el-dialog title="查看二维码" :visible.sync="qrcodeVisible" width="300px" :close-on-click-modal="false">
      <div class="qr-code-inner">
        <!-- <vue-qr class="qr-code" :text="text" :margin="12" colorDark="#7EBF50" height="220" width="220" /> -->
        <vue-qr class="qr-code-down5" :text="text" :margin="12" colorDark="#7EBF50" :size="size" />

        <p class="text">
          {{ qrcodeInfo.licenseNo }} {{ qrcodeInfo.vehicleSeat }}座
        </p>
        <p class="text">
          {{ qrcodeInfo.driverName }} {{ qrcodeInfo.driverPhone }}
        </p>
        <p class="util-remark">使用小程序扫码快速购票</p>
        <el-checkbox v-model="checked">二维码显示车辆号牌</el-checkbox>
        <el-select v-model="size">
          <el-option v-for="item in sizeOpt" :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
        <p class="util-click-text" @click="downloadQrcode">下载二维码</p>
      </div>
    </el-dialog>

    <div class="vehicleSupervise">
      <vehicleSupervise :vehicleId="vehicleId" v-model="showSupervise"></vehicleSupervise>
    </div>

    <el-drawer :visible.sync="showDzCreate" destroy-on-close :wrapperClosable="false" :before-close="handClose" size="50%">
      <DzCreate @cancel="handClose('cancel')" @success="handClose('success')" title="创建车辆"></DzCreate>
    </el-drawer>
  </div>
</template>
<script>
import VueQr from "vue-qr";
import vehicleSupervise from "../components/vehicleSupervise";
import DzCreate from "./DzCreate.vue";
export default {
  name: "shift",
  components: {
    VueQr,
    vehicleSupervise,
    DzCreate
  },
  data() {
    return {
      showDzCreate: false,
      checked: false,
      size: 128,
      sizeOpt: [
        {
          value: 128,
          label: "128*128",
        },
        {
          value: 256,
          label: "256*256",
        },
        {
          value: 512,
          label: "512*512",
        },
        {
          value: 1024,
          label: "1024*1024",
        },
      ],
      // 查看二维码
      qrcodeVisible: false,
      // 查看二维码
      qrcodeInfo: {},
      // 二维码内容
      text: "",
      // 按钮加载状态
      loading: false,
      // 司机值班id
      id: "",
      // 司机值班
      visible: false,
      // 关键字搜索
      keyWords: "",
      // 车辆组织机构
      organizationId: "",
      // 车辆组织机构
      organizationName: "",
      // 选中的司机列表
      driverId: "",
      // 搜索的列表
      searchDrivers: [],
      // 司机列表
      drivers: [],
      // 司机列表
      page: 1,
      // 司机总数
      total: 0,
      //车辆id
      vehicleId: "",
      showSupervise: false,
    };
  },
  computed: {
    // 基础列配置
    baseColumns() {
      return [
        { prop: "vehiclePhoto", label: "车辆照片", width: 150 },
        { prop: "licenseNo", label: "车辆号牌", width: 160 },
        { prop: "vehicleModel", label: "车辆型号", width: 200 },
        { prop: "vehicleColor", label: "车身颜色", width: 100 },
        { prop: "vehicleSeat", label: "座位数量", width: 100 },
        { prop: "driverName", label: "司机姓名", width: 130 },
        { prop: "applyTime", label: "提交认证时间", width: 160 },
        { prop: "created", label: "认证通过时间", width: 160 },
      ]
    },
    // 扩展列配置（专线/旅游平台）
    extendedColumns() {
      return [
        { prop: "vehiclePhoto", label: "车辆照片", width: 150 },
        { prop: "licenseNo", label: "车辆号牌", width: 160 },
        { prop: "vehicleNo", label: "车辆编号", width: 200 },
        { prop: "vehicleModel", label: "车辆型号", width: 120 },
        { prop: "vehicleColor", label: "车身颜色", width: 100 },
        { prop: "vehicleSeat", label: "座位数量", width: 100 },
        { prop: "driverName", label: "值班司机", width: 130 },
        { prop: "vehicleResponsible", label: "车辆责任人", width: 120 },
        { prop: "companyName", label: "车辆所属", width: 160 },
      ]
    },
    // 基础搜索配置
    baseSearch() {
      return [
        { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
        { type: "input", field: "driverName", name: "车辆司机", value: "" },
        { type: "select", field: "vehicleSeat", name: "座位数量", value: "", option: this.$const.SEATNUMBER },
      ]
    },
    // 扩展搜索配置（专线/旅游平台）
    extendedSearch() {
      return [
        { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
        { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
        { type: "input", field: "driverName", name: "值班司机", value: "" },
        { type: "input", field: "vehicleResponsible", name: "车辆责任人", value: "" },
        { type: "input", field: "companyName", name: "车辆所属", value: "" },
        { type: "select", field: "vehicleSeat", name: "座位数量", value: "", option: this.$const.SEATNUMBER },
      ]
    },
    // 基础导入列配置
    baseImportColumns() {
      return [
        { prop: "licenseNo", label: "车辆号牌", required: true },
        { prop: "licenseColor", label: "号牌颜色", required: true },
        { prop: "vehicleModel", label: "车辆型号", required: true },
        { prop: "vehicleColor", label: "车身颜色", required: true },
        { prop: "vehicleSeat", label: "座位数量", required: true },
        { prop: "organizationName", label: "机构名称", required: true },
        { prop: "vehiclePhoto", width: 120, label: "车辆照片", required: true },
        { prop: "drivingLicenseFront", width: 120, label: "行驶证正面", required: true },
        { prop: "useCharacter", width: 120, label: "车辆使用性质", required: true },
        { prop: "registerDate", width: 120, label: "车辆注册日期", required: true },
      ]
    },
    // 扩展导入列配置（专线/旅游平台）
    extendedImportColumns() {
      return [
        { prop: "licenseNo", label: "车辆号牌", required: true },
        { prop: "licenseColor", label: "号牌颜色", required: true },
        { prop: "vehicleNo", label: "车辆编号" },
        { prop: "vehicleModel", label: "车辆型号", required: true },
        { prop: "vehicleColor", label: "车身颜色", required: true },
        { prop: "vehicleSeat", label: "座位数量", required: true },
        { prop: "vehicleResponsible", label: "车辆责任人", width: 100 },
        { prop: "organizationName", label: "机构名称", required: true },
        { prop: "vehiclePhoto", width: 120, label: "车辆照片", required: true },
        { prop: "roadTransportCertificate", width: 120, label: "道路运输证", required: true },
        { prop: "drivingLicenseFront", width: 120, label: "行驶证正面", required: true },
        { prop: "drivingLicenseBack", width: 120, label: "行驶证背面", required: true },
      ]
    },
    pageConfig() {
      const platformType = this.mixinUserInfo.platformType
      const isOrgType1 = this.mixinUserInfo.organizationType === 1
      
      // 默认配置
      let config = {
        customOptions: {
          url: "/api/v1/manage/vehicle",
          params: { page: 1, size: 20 },
          search: this.baseSearch,
        },
        columns: this.baseColumns,
        importColumns: this.baseImportColumns,
        importRules: ["vehiclePhoto", "drivingLicenseFront"],
        excelType: '',
        hasChannel: false,
        importExcel: '',
        importDes: "车辆号牌码-证件名称，例如：川A66666-行驶证正面",
        importRemark: ['车辆注册日期yyyymmdd，例如：20231231']
      }

      // 根据平台类型配置
      switch (platformType) {
        case 1: // 专线平台
        case 2: // 旅游平台
          config.excelType = 'Vehicle'
          config.importExcel = isOrgType1 ? '/vehicles.xlsx' : '/vehicle.xlsx'
          config.importDes = "车辆号牌码-证件名称，例如：川A66666-道路运输证"
          config.importRemark = []
          config.customOptions.search = this.extendedSearch
          config.columns = this.extendedColumns
          config.importColumns = this.extendedImportColumns
          config.importRules = ["vehiclePhoto", "roadTransportCertificate", "drivingLicenseFront", "drivingLicenseBack"]
          break
        case 3: // 顺风车平台
          config.hasChannel = true
          config.excelType = 'VehicleHitchRide'
          config.importExcel = isOrgType1 ? '/sfxVehicles.xlsx' : '/sfxVehicle.xlsx'
          // 顺风车平台额外显示归属渠道列
          config.columns = [...this.baseColumns, { prop: "channelName", label: "归属渠道", width: 120 }]
          break
        case 4: // 机场平台
          config.excelType = 'VehicleAirport'
          config.importExcel = isOrgType1 ? '/sfxVehicles.xlsx' : '/sfxVehicle.xlsx'
          break
      }
      return config
    }
  },
  methods: {
    handClose(type) {
      console.log(type);
      this.showDzCreate = false;
      if (type === 'success') {
        this.$refs.customTable.listFn()
      }
    },
    editClick(row) {
      if (!this.btnPreFn(this.$route.name + "_edit")) {
        return;
      }
      this.$router.push({ path: "/vehicleDetail", query: { id: row.id } });
    },
    handleCommand(e, row) {
      switch (e) {
        case "add":
        case "update":
          this.visibleShow(row);
          break;
        case "remove":
          this.removeClick(row);
          break;
        case "unbind":
          this.unbundleClick(row.id);
          break;
        case "qrcode":
          this.qrcodeClick(row);
          break;

        case "surveyVehicle":
          this.vehicleId = row.id;
          this.showSupervise = true;
          break;
      }
    },
    /**
     * 点击创建司机
     */
    addFn() {
      if (this.mixinUserInfo.platformType === 1) {
        this.showDzCreate = true;
      } else {
        this.$router.push({ path: "/vehicleCreate" });
      }
    },
    async ifEdit(vehicleId) {
      let bl = false;
      let url = "/api/v1/manage/vehicle/isServiceOrder";
      let params = {
        vehicleId,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        bl = data.data;
      } else {
        bl = true;
      }
      return bl;
    },
    /**
     * 司机弹框显示
     */
    async visibleShow(row) {
      if (!this.btnPreFn(this.$route.name + "_driver")) {
        return;
      }

      // 判断是否可以编辑
      if (await this.ifEdit(row.id)) {
        this.$message.warning("该车辆还有行程中的订单，无法编辑司机");
        return;
      }

      this.keyWords = "";
      this.driverId = row.driverId ? Number(row.driverId) : "";
      this.organizationId = row.organizationId;
      this.organizationName = row.organizationName;
      this.id = row.id;
      this.visible = true;
      this.page = 1;
      this.drivers = await this.getDrivers({
        organizationId: this.organizationId,
      });
      this.searchDrivers = await this.getDrivers({
        keyWords: this.keyWords,
        organizationId: this.organizationId,
      });
    },
    /**
     * 在下拉列表上选择司机
     */
    async selectChange(query) {
      this.driverId = query;
    },
    /**
     * 搜索司机
     */
    async remoteMethod(query) {
      this.searchDrivers = await this.getDrivers({
        keyWords: query,
        organizationId: this.organizationId,
        page: 1,
      });
    },
    /**
     * 获取司机列表
     */
    async getDrivers(obj = {}) {
      let url = "/api/v1/manage/vehicle/driver";
      let params = Object.assign(
        {
          page: this.page,
          size: 10,
        },
        obj
      );
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.total = data.total || 0;
        return data.data || [];
      } else {
        return [];
      }
    },
    /**
     * 点击更多
     */
    async moreClick() {
      if (this.drivers.length < this.total) {
        this.page++;
        let list = await this.getDrivers({
          organizationId: this.organizationId,
        });
        this.drivers = [...this.drivers, ...list];
      }
    },
    /* 接口请求-保存 */
    async postFn() {
      this.loading = true;
      let url = "/api/v1/manage/vehicle/duty";
      let params = {
        id: this.id,
        driverId: this.driverId,
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("添加成功！");
        this.$refs.customTable.listFn();
        this.visible = false;
      }
      this.loading = false;
    },
    /**
     * 查看二维码
     */
    async qrcodeClick(row) {
      this.vehicleId = row.id;
      this.size = 128;
      this.qrcodeVisible = true;
      this.qrcodeInfo = row;
      let url = "/api/v1/manage/vehicle/qr_code";
      let params = {
        vehicleId: row.id,
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.text = data.data;
      }
    },
    /**
     * 下载二维码
     */
    async downloadQrcode() {
      if (this.checked) {
        // let url = "/api/v1/common/qrCode/download";
        // let params = {
        //   vehicleId: this.vehicleId,
        //   qrUrl: this.text,
        //   width: this.size,
        //   height: this.size,
        // };
        // let data = await this.$axios.post(url, params);
        //

        // const myBlob = new window.Blob([data], { type: "image/png" });
        //
        // const qrUrl = window.URL.createObjectURL(myBlob);
        //
        let a = document.createElement("a");
        a.href = `/api/v1/common/qrCode/download?vehicleId=${this.vehicleId}&qrUrl=${this.text}&width=${this.size}&height=${this.size}&appKey=${this.mixinUserInfo.appKey}`;
        a.download = "二维码";
        a.click();
      } else {
        let oQrcode = document.getElementsByClassName("qr-code-down5")[0];
        let a = document.createElement("a");
        a.href = oQrcode.src;

        a.download = "二维码";
        a.click();
      }
    },
    /**
     * 司机解绑
     */
    async unbundleClick(id) {
      if (!this.btnPreFn(this.$route.name + "_unbundling")) {
        return;
      }

      this.$confirm(
        "解除司机与车辆绑定后，该司机将无法接单，确认解绑司机吗？",
        "解绑提示"
      ).then(async () => {
        let url = "/api/v1/manage/vehicle/duty/" + id;
        let data = await this.$axios.delete(url);
        if (data && data.code === 1) {
          this.$message.success("解绑成功！");
          this.$refs.customTable.listFn();
        }
      });
    },
    /**
     * 司机删除
     */
    async removeClick(row) {
      if (!this.btnPreFn(this.$route.name + "_remove")) {
        return;
      }
      this.$confirm(
        row.driverName
          ? "该车辆已绑定司机，删除后将自动解绑，确定删除该车辆吗？"
          : "确定删除该车辆吗？",
        "提示"
      ).then(async () => {
        let url = "/api/v1/manage/vehicle";
        let params = {
          id: row.id,
        };
        let data = await this.$axios.delete(url, params);
        console.log(data);
        if (data && data.code === 1) {
          this.$message.success("删除成功！");
          this.$refs.customTable.listFn();
        }else {
          this.$refs.customTable.listFn();
        }
      });
    },
  },
  created() {
    // 配置已移至 computed pageConfig 中
  },
};
</script>

<style scoped lang="less">
#shift {
  // 操作按钮样式
  .custom-action {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .el-button--text {
      padding: 0;
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
    
    .el-dropdown-link {
      color: #2B77FF;
      cursor: pointer;
      font-size: 12px;
      
      &:hover {
        color: #1a5fd9;
      }
    }
  }

  .el-dialog {
    border-radius: 8px;
    
    .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
    
    .el-dialog__body {
      padding: 20px;
    }

    .label {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      margin-bottom: 12px;
      margin-top: 16px;
      
      &:first-child {
        margin-top: 0;
      }
    }

    .el-select {
      width: 100%;
      
      .el-input__inner {
        border-radius: 6px;
      }
    }

    .el-radio-group {
      width: 100%;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      padding: 16px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      gap: 8px 16px;
      background: #fafbfc;

      .el-radio {
        margin: 0;
      }

      .el-radio__label {
        font-size: 14px;
        color: #606266;
      }
    }

    .dialog-more {
      font-size: 14px;
      color: #2B77FF;
      text-align: center;
      line-height: 40px;
      margin-top: 8px;
      transition: all 0.2s;

      &:hover {
        cursor: pointer;
        color: #1a5fd9;
      }
    }
    
    .dialog-footer {
      .el-button {
        min-width: 80px;
        border-radius: 6px;
      }
    }

    .qr-code-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 24px;

      .qr-code,
      .qr-code-down5 {
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        margin-bottom: 16px;
      }

      .text {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }

      .util-remark {
        font-size: 12px;
        color: #909399;
        margin: 8px 0;
      }

      .el-checkbox {
        margin-bottom: 8px;
      }

      .el-select {
        margin: 8px 0;
        width: 140px;

        .el-input {
          width: 100%;
        }
      }

      .util-click-text {
        color: #2B77FF;
        cursor: pointer;
        font-size: 14px;
        margin-top: 8px;
        
        &:hover {
          color: #1a5fd9;
          text-decoration: underline;
        }
      }
    }
  }

  .column-img {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    object-fit: cover;
  }

  .vehicleSupervise {
    .el-dialog {
      .el-dialog__body {
        padding-top: 16px;
      }

      .el-radio-group {
        width: 100%;
        border: none;
        padding: 0;
        background: transparent;
        display: flex;
        flex-wrap: wrap;
        gap: 8px 16px;

        .el-radio {
          margin: 0;
        }

        .el-radio__label {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
